import { Routes } from '@angular/router';
import { WebLayoutComponent } from '@shared/components/layouts/web-layout/web-layout.component';
import { ComingSoonLayoutComponent } from './shared/components/layouts/coming-soon-layout/coming-soon-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: WebLayoutComponent,
    loadChildren: () => import('./modules').then((m) => m.routes),
  },
  {
    path: 'coming-soon',
    component: ComingSoonLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/comingsoon/comingsoon.component').then((m) => m.ComingsoonComponent)
      },
    ],
  },
];
